// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/DotGothic16-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/PressStart2P-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/PixelifySans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/GohuFont14NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/BigBlueTerm437NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/HeavyDataNerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DotGothic16";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"); }

@font-face {
  font-family: "Press Start 2P";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Pixelify Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Gohu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Big Blue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Heavy Data";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

:root {
  --main-font: "Pixelify Sans", sans-serif;
  --clock-font: "DotGothic16", sans-serif;
  --log-in-font: "Press Start 2P", sans-serif;
  --Gohu-test: "Gohu", sans-serif;
  --Big-Blue-test: "Big Blue", sans-serif;
  --Heavy-Data-test: "Heavy Data", sans-serif; }

.drop-down-container {
  background-color: white;
  color: black; }

.option-container {
  position: absolute;
  top: 38px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 1;
  transition: opacity .5s;
  font-family: var(--main-font); }
  .option-container > div {
    background-color: #cccccc;
    border-top: 1px white solid;
    border-right: 1px black solid;
    border-bottom: 1px black solid;
    border-left: 1px white solid; }
    .option-container > div:hover {
      cursor: pointer;
      background-color: #bebebe; }
    .option-container > div:active {
      background-color: #969696;
      border-top: 1px black solid;
      border-right: 1px white solid;
      border-bottom: 1px white solid;
      border-left: 1px black solid; }
  .option-container.invisible {
    display: none; }
`, "",{"version":3,"sources":["webpack://./src/components/style_imports/_fonts.scss","webpack://./src/components/DropDownMenu/DropDown.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,+DAAkE,EAAA;;AAGtE;EACI,6BAA6B;EAC7B,4CAAgD,EAAA;;AAGpD;EACI,4BAA4B;EAC5B,4CAAgD,EAAA;;AAGpD;EACI,mBAAmB;EACnB,4CAAsD,EAAA;;AAG1D;EACI,uBAAuB;EACvB,4CAA0D,EAAA;;AAG9D;EACI,yBAAyB;EACzB,4CAAqD,EAAA;;AAGzD;EACI,wCAAY;EACZ,uCAAa;EACb,2CAAc;EACd,+BAAY;EACZ,uCAAgB;EAChB,2CAAkB,EAAA;;AClCtB;EACI,uBAAuB;EACvB,YAAY,EAAA;;AAMhB;EAEI,kBAAkB;EAClB,SAAS;EACT,YAAY;EAEZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAE9B,UAAU;EACV,uBAAuB;EAEvB,6BAA6B,EAAA;EAbjC;IAiBQ,yBAAoC;IAEpC,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B,EAAA;IAtBpC;MAyBY,eAAe;MACf,yBAAoC,EAAA;IA1BhD;MA8BY,yBAAoC;MAEpC,2BAA2B;MAC3B,6BAA6B;MAC7B,8BAA8B;MAC9B,4BAA4B,EAAA;EAnCxC;IAwCQ,aAAa,EAAA","sourcesContent":["@font-face {\n    font-family: \"DotGothic16\";\n    src: url(\"../../fonts/DotGothic16-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"Press Start 2P\";\n    src: url(\"../../fonts/PressStart2P-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Pixelify Sans\";\n    src: url(\"../../fonts/PixelifySans-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Gohu\";\n    src: url(\"../../fonts/GohuFont14NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Big Blue\";\n    src: url(\"../../fonts/BigBlueTerm437NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Heavy Data\";\n    src: url(\"../../fonts/HeavyDataNerdFont-Regular.ttf\");\n}\n\n:root {\n    --main-font: \"Pixelify Sans\", sans-serif;\n    --clock-font: \"DotGothic16\", sans-serif;\n    --log-in-font: \"Press Start 2P\", sans-serif;\n    --Gohu-test: \"Gohu\", sans-serif;\n    --Big-Blue-test: \"Big Blue\", sans-serif;\n    --Heavy-Data-test: \"Heavy Data\", sans-serif;\n}","@import '../style_imports/fonts';\n\n.drop-down-container {\n    background-color: white;\n    color: black;\n\n}\n\n\n\n.option-container {\n    // background-color: black;\n    position: absolute;\n    top: 38px;\n    z-index: 100;\n    // height: 205px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    // opacity: 0;\n    opacity: 1;\n    transition: opacity .5s;\n\n    font-family: var(--main-font);\n\n    &>div {\n        // background-color: white;\n        background-color: rgb(204, 204, 204);\n\n        border-top: 1px white solid;\n        border-right: 1px black solid;\n        border-bottom: 1px black solid;\n        border-left: 1px white solid;\n\n        &:hover {\n            cursor: pointer;\n            background-color: rgb(190, 190, 190);\n        }\n\n        &:active {\n            background-color: rgb(150, 150, 150);\n\n            border-top: 1px black solid;\n            border-right: 1px white solid;\n            border-bottom: 1px white solid;\n            border-left: 1px black solid;\n        }\n    }\n\n    &.invisible {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
